import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
    return (
        <nav className="navbar">
            
            <ul className="navbar-list">
                <li>
                    <Link className="navbar-link" to="/menu">Menu</Link>
                </li>
                <li>
                    <Link className="navbar-link" to="/about">Prenota</Link>
                </li>
                <li>
                    <Link className="navbar-link" to="/calendario">Calendario</Link>
                </li>
                <li>
                    <Link className="navbar-link" to="/contact">Contattaci</Link>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;